import { render, staticRenderFns } from "./PremiumPage.vue?vue&type=template&id=344cd989&scoped=true&"
import script from "./PremiumPage.vue?vue&type=script&lang=js&"
export * from "./PremiumPage.vue?vue&type=script&lang=js&"
import style0 from "./PremiumPage.vue?vue&type=style&index=0&id=344cd989&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cd989",
  null
  
)

component.options.__file = "PremiumPage.vue"
export default component.exports